export const menusData = [
    {
        path: '/modify-passworld',
        name: 'modify-passworld',
        url: 'modify-passworld',
        icon: '',
        show: false,
        meta: { title: '', i18n: '修改密码' }
    },
    {
        path: '/home-page',
        name: 'home-page',
        url: 'home-page',
        icon: 'shouye',
        show: true,
        meta: { title: '首页', i18n: '首页' }
    },
    {
        path: '/large-data-screen',
        name: 'Layout',
        url: 'Layout',
        icon: 'daping',
        show: true,
        meta: { title: '数据看板', i18n: '数据看板' }
    },
    {
        path: '/river-information',
        name: 'river-information',
        url: 'river-information',
        icon: 'hedao_icon',
        show: true,
        meta: { title: '河道信息', i18n: '河道信息' }
    },
    {
        path: '/river-information-detail',
        name: 'river-information-detail',
        url: 'river-information/components/detail',
        icon: '',
        show: false,
        meta: { title: '河道详情', i18n: '河道详情' }
    },
    {
        path: '/device-monitoring',
        name: 'device-monitoring',
        url: 'device-monitoring',
        icon: 'shebei',
        show: true,
        meta: { title: '设备监测', i18n: '设备监测' }
    },
    {
        path: '/alarm-monitoring',
        name: 'alarm-monitoring',
        url: 'alarm-monitoring',
        icon: 'gaojing',
        show: true,
        meta: { title: '告警查询', i18n: '告警查询' }
    },
    {
        path: '/device-operation',
        name: 'device-operation',
        url: 'device-operation',
        icon: 'shebeiyunwei',
        show: true,
        meta: { title: '设备运维', i18n: '设备运维' }
    },
    {
        path: '/device-operation-detail',
        name: 'device-operation-detail',
        url: 'device-operation/components',
        icon: '',
        show: false,
        meta: { title: '设备运维-详情', i18n: '设备运维-详情' }
    },
    {
        path: '/system-notice',
        name: 'system-notice',
        url: 'system-notice',
        icon: 'notice',
        show: true,
        meta: { title: '系统通知', i18n: '系统通知' }
    },
    {
        path: '/platform-ai',
        name: 'Layout',
        url: 'Layout',
        icon: 'daping',
        show: true,
        meta: { title: 'ai', i18n: 'ai' }
    }
    // {
    //     path: '/river-information-detail',
    //     name: 'river-information-detail',
    //     url: 'river-information/detail',
    //     icon: '',
    //     show: false,
    //     meta: { title: '', i18n: '河道详情' }
    // },
    // {
    //     path: '/water-quality-monitoring',
    //     name: 'water-quality-monitoring',
    //     url: 'water-quality-monitoring',
    //     icon: 'shuizhi',
    //     show: true,
    //     meta: { title: '', i18n: '水质监测' }
    // },
    // {
    //     path: '/water-quality-monitoring-detail',
    //     name: 'water-quality-monitoring-detail',
    //     url: 'water-quality-monitoring/detail',
    //     icon: '',
    //     show: false,
    //     meta: { title: '', i18n: '水质详情' }
    // },
    // {
    //     path: '/maintenance-report',
    //     name: 'maintenance-report',
    //     url: 'maintenance-report',
    //     icon: 'baogao',
    //     show: true,
    //     meta: { title: '', i18n: '运维报告' }
    // },
    // {
    //     path: '/maintenance-report-detail',
    //     name: 'maintenance-report-detail',
    //     url: 'maintenance-report/detail',
    //     icon: 'baogao',
    //     show: false,
    //     meta: { title: '', i18n: '报告详情' }
    // },
    // {
    //     path: '/work-order-progress',
    //     name: 'work-order-progress',
    //     url: 'work-order-progress',
    //     icon: 'gongdan',
    //     show: true,
    //     meta: { title: '', i18n: '工单进度' }
    // },
    // {
    //     path: '/work-order-progress-detail',
    //     name: 'work-order-progress-detail',
    //     url: 'work-order-progress/detail',
    //     icon: 'gongdan',
    //     show: false,
    //     meta: { title: '', i18n: '工单详情' }
    // }
]
